// extracted by mini-css-extract-plugin
module.exports = {"main-component":"titleUnderline_main-component__FO85g"};